import { motion } from "framer-motion";
import { Wrench } from "lucide-react";
import { useSiteMode } from "@/contexts/SiteModeContext";
import logo from "@/assets/Weautomate logo-01.png";

export default function Maintenance() {
  const { modeData } = useSiteMode();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[#9D4CDD] opacity-[0.06] blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 flex flex-col items-center"
      >
        <img src={logo} alt="WeAutomate" className="h-12 w-auto mb-12" />

        <motion.div
          animate={{ rotate: [0, -12, 12, -8, 8, 0] }}
          transition={{ duration: 1.2, delay: 0.6, ease: "easeInOut" }}
          className="mb-8"
        >
          <div className="w-20 h-20 rounded-2xl gradient-bg flex items-center justify-center">
            <Wrench className="w-10 h-10 text-white" />
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-5xl lg:text-7xl tracking-tighter gradient-text leading-tight max-w-2xl"
        >
          {modeData.title || "We're tightening a few bolts."}
        </motion.h1>

        {modeData.message && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-6 text-lg text-white/60 max-w-md leading-relaxed"
          >
            {modeData.message}
          </motion.p>
        )}

        {!modeData.message && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-6 text-lg text-white/50 max-w-md"
          >
            We're making things better. Won't be long.
          </motion.p>
        )}

        {modeData.eta && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/10 text-sm text-white/50 font-mono"
          >
            Back by {modeData.eta}
          </motion.div>
        )}

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-12 text-sm text-white/40"
        >
          Need to reach us?{" "}
          <a href="mailto:hello@weautomate.tech" className="text-accent hover:underline">
            hello@weautomate.tech
          </a>
        </motion.p>
      </motion.div>
    </div>
  );
}
